/**
 * Persistent mobile buy bar. Paired with snippets/hh-sticky-buy.liquid.
 *
 * Shows once the visitor is past the hero, hides again whenever a real buy
 * module is on screen so there are never two competing CTAs.
 *
 * Deliberately does not read window.innerHeight for its threshold: Instagram
 * and Facebook resize the webview when their toolbars show and hide, so a
 * height-derived threshold would drift mid-scroll. A fixed pixel threshold is
 * stable.
 */
(function () {
  var SHOW_AFTER_FALLBACK = 700; // just past the hero on a phone

  function init() {
    var bar = document.querySelector('[data-hh-stickybuy]');
    if (!bar) return;

    var showAfter = parseInt(bar.getAttribute('data-show-after'), 10);
    if (isNaN(showAfter) || showAfter < 0) showAfter = SHOW_AFTER_FALLBACK;

    var link = bar.querySelector('[data-hh-stickybuy-link]');
    var target = link && link.getAttribute('href');

    /* If the buy card is not on this page there is nothing to jump to. */
    if (target && target.charAt(0) === '#' && !document.querySelector(target)) {
      return;
    }

    var nearSelectors = (bar.getAttribute('data-hide-near') || '')
      .split(',')
      .map(function (s) {
        return s.trim();
      })
      .filter(Boolean);

    var buyModuleOnScreen = false;

    if (window.IntersectionObserver && nearSelectors.length) {
      var observed = [];
      for (var i = 0; i < nearSelectors.length; i++) {
        var el = document.querySelector(nearSelectors[i]);
        /* Anchors are often empty marker spans with no height, so watch the
           section they sit in rather than the marker itself. */
        if (el && !el.getBoundingClientRect().height) {
          el = el.closest('[id^="shopify-section"]') || el;
        }
        if (el && observed.indexOf(el) === -1) observed.push(el);
      }

      var visible = [];
      var io = new IntersectionObserver(
        function (entries) {
          for (var j = 0; j < entries.length; j++) {
            var e = entries[j];
            var at = visible.indexOf(e.target);
            if (e.isIntersecting && at === -1) visible.push(e.target);
            if (!e.isIntersecting && at !== -1) visible.splice(at, 1);
          }
          buyModuleOnScreen = visible.length > 0;
          update();
        },
        { rootMargin: '-10% 0px -10% 0px' }
      );

      for (var k = 0; k < observed.length; k++) io.observe(observed[k]);
    }

    bar.hidden = false;

    var ticking = false;

    function update() {
      ticking = false;
      var show = window.scrollY > showAfter && !buyModuleOnScreen;
      if (show === bar.classList.contains('is-visible')) return;
      bar.classList.toggle('is-visible', show);
      /* Keep it out of the tab order and off screen readers while hidden. */
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (link) link.tabIndex = show ? 0 : -1;
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
